import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"
import { OVERVIEW_PAGE_CONTENT } from "../Dashboard/constants"
import { getAssetPath } from "../../utils/assets"

const StyledNav = styled.nav`
  img:first-child {
    width: 64px;
    margin-right: 1em;
  }
  img:last-child {
    display: none;
    @media (min-width: 768px) {
      display: inline-block;
    }
  }
`

function SurveyHeader({ form, onSaveHandler }) {
  return (
    <div className="fixed-top">
      <StyledNav className="navbar navbar-light bg-white">
        <Link to="/ten-dwc-dashboard">
          <img src={getAssetPath(OVERVIEW_PAGE_CONTENT["10DWC"].logoAssetName)} width={64} height={64} />
          <img src={getAssetPath("10dwc-word-logo")} width={240} height={36} />
        </Link>
        {onSaveHandler && <button className="btn btn-outline-main btn-sm" type="button" onClick={onSaveHandler}>Save Draft</button>}
      </StyledNav>
      <div className="progress survey-progress">
        <div
          aria-valuemax={100}
          aria-valuemin={0}
          aria-valuenow={0}
          aria-label="10DWC survey completion"
          style={{ width: `${((form?.length || 0) / 110) * 100}%` }}
          className="progress-bar"
          role="progressbar" />
      </div>
    </div>
  )
}

export default SurveyHeader